import Highcharts from "highcharts";

declare module "highcharts" {
  interface ChartEventsOptions {
    tooltipClick?: (this: Highcharts.Chart, e: Highcharts.TooltipClickEventObject) => void;
  }

  interface TooltipClickEventObject extends Event {
    points: Highcharts.Point[];
    action: string;
  }
}

export default function tooltipClick(H: typeof Highcharts) {
  H.addEvent(H.Chart, "load", function (this: Highcharts.Chart) {
    if (!this.options.tooltip?.sticky) return;

    const handleStickyTooltipClick = (e: Event | Highcharts.Dictionary<unknown> | undefined) => {
      if (!e || !(e instanceof Event)) throw new Error("e was supposed to be an event");
      if (!(e.target instanceof HTMLElement) || !e.target.getAttribute("data-action")) return;
      this.tooltip.hide(0);
      const points = this.getSelectedPoints();
      for (const p of points) p.select(false);
      const action = e.target.getAttribute("data-action");
      Highcharts.fireEvent(this, "tooltipClick", { ...e, points, action });
    };

    H.addEvent(this.tooltip, "refresh", function (this: Highcharts.Tooltip) {
      if (!this.container) return;
      H.removeEvent(this.container, "click", handleStickyTooltipClick);
      H.addEvent(this.container, "click", handleStickyTooltipClick);
    });

    H.addEvent(this, "destroy", () => {
      if (this.tooltip.container)
        H.removeEvent(this.tooltip.container, "click", handleStickyTooltipClick);
    });
  });
}
